module.exports = __webpack_public_path__ + "media/images/illustrations/wave-blue-1-b1110ce33494e598be93d08de411e0fb.svg";